export const NAME = 'footballPlayers';
export const PLAYERS_API = 'https://football-players-b31f2.firebaseio.com/players.json?print=pretty';
export const POSITIONS = [
  'Attacking Midfield',
  'Central Midfield',
  'Centre-Back',
  'Centre-Forward',
  'Defensive Midfield',
  'Keeper',
  'Left Midfield',
  'Left Wing',
  'Left-Back',
  'Right-Back'
];



// WEBPACK FOOTER //
// ./src/footballPlayers/constants/index.js